import React from "react";
import {ButtonPrimary} from "./style";

export default function Button ({children, href, target}) {
  return (
    <ButtonPrimary href={href} target={target}>{children}</ButtonPrimary>
  )
}